<template>
    <div class="merchantList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="searchForm.nick_name"
                        placeholder="请输入销售名称"
                    ></el-input>
                </el-form-item>
              <el-form-item>
              <el-input
                  size
                  clearable
                  v-model="searchForm.mobile"
                  placeholder="请输入手机号"
              ></el-input>
              </el-form-item>
                <el-form-item>
                    <el-select size v-model="searchForm.status" clearable placeholder="请选择商户状态">
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="已注销" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="注册开始日期"
                        end-placeholder="注册结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                :data="saleList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 销售名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="nick_name"
                    label="销售名称"
                    min-width="120"
                ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="mobile"
				    label="销售账号"
				    min-width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop=""
				    label="身份证正面"
				    min-width="120"
				>
				<template slot-scope="scope">
				    <img @click="viewImage(scope.row.card_positive_photo)"  width="60" height="60" :src="scope.row.card_positive_photo" alt="加载中"/>
				</template>
				</el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop=""
				    label="身份证反面"
				    min-width="120"
				>
				<template slot-scope="scope">
				    <img @click="viewImage(scope.row.card_negative_photo)"   width="60" height="60"  :src="scope.row.card_negative_photo" alt="加载中"/>
				</template>
				</el-table-column>
                <!-- 商户状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="status"
                    label="状态"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">正常</span>
                        <span style="color:#f00" v-if="scope.row.status == 2">已注销</span>
                    </template>
                </el-table-column>
				<!-- 注册时间 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="create_time"
				    label="注册时间"
				    min-width="150"
				></el-table-column>
				<!-- 月结钱包提现比例 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="month_ratio"
				    label="月结钱包提现比例"
				    min-width="150"
				>
				<template slot-scope="scope">
				    <span>{{scope.row.month_ratio}}%</span>
				</template>
				</el-table-column>
				<!-- 年结钱包提现比例 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="year_ratio"
				    label="年结钱包提现比例"
				    min-width="150"
				>
				<template slot-scope="scope">
				    <span>{{scope.row.year_ratio}}%</span>
				</template>
				</el-table-column>
				<!-- 注销时间 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="signout_time"
				    label="注销时间"
				    min-width="150"
				></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="250"
                >
                    <template slot-scope="scope">
                      <el-button style="color: #f00;" v-if="scope.row.status == 1" @click="cellClick(scope.row,'注销')" type="text" size="small">注销</el-button>
					  <el-button style="color: #81B437;" v-if="scope.row.status == 2" @click="cellClick(scope.row,'启用')" type="text" size="small">启用</el-button>
					  <el-button v-if="scope.row.status == 1" @click="cellClick(scope.row,'修改提现比例')" type="text" size="small">修改提现比例</el-button>
					  <el-button @click="cellClick(scope.row,'奖励明细')" type="text" size="small">奖励明细</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
		<!-- 查看图片 -->
		<image-viwe v-if="picDialog" :onClose="handleCloseImgView" :urlList="[picUrl]"></image-viwe>
		<!-- 修改提现比例弹窗 -->
		<el-dialog title="修改提现比例" :visible.sync="changeWindowState" class="dialog">
		  <el-form  label-position="right" :model="changeForm" ref="changeForm" label-width="180px"  :rules="rules" >
		     <el-form-item label="月结钱包提现比例："   prop="month_ratio">
				 <el-col :span="20">
					<el-input   v-model="changeForm.month_ratio" autocomplete="off"></el-input>
				 </el-col>
				 <el-col :span="4">
					<span style="margin-left: 5px;">%</span>
				 </el-col>
		     </el-form-item>
			 <el-form-item label="年结钱包提现比例："    prop="year_ratio">
			   <el-col :span="20">
			   		<el-input  v-model="changeForm.year_ratio" autocomplete="off"></el-input>
			   </el-col>
			   <el-col :span="4">
			   		<span style="margin-left: 5px;">%</span>			
			   </el-col>
			 </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="changeWindowState = false">取 消</el-button>
		    <el-button type="primary" @click="addSubmit()">确 定</el-button>
		  </div>
		</el-dialog>
    </div>
</template>

<script>
import imageViwe from '../../../node_modules/element-ui/packages/image/src/image-viewer';
export default {
    name: "saleMangerPerson",
	components: {
	    imageViwe
	},
    data() {
        return {
			picDialog: false, //查看图片
			picUrl: '',
            searchForm: {
                nick_name: '',
                status: '',
                mobile: '',
                start_time: '',
                end_time: '',
				limit:10,
				page: 1
            },
			changeWindowState:false,
			changeForm:{
				month_ratio:'',
				year_ratio:'',
				person_id:''
			},
            rangeDate: '',
            saleList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
			rules: {
				month_ratio: [{
					required: true,
					message: '请输入月结钱包提现比例',
					trigger: 'blur'
				}],
				year_ratio: [{
					required: true,
					message: '请输入年结钱包提现比例',
					trigger: 'blur'
				}],
			},
        }
    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    methods: {
		viewImage(picUrl) { //查看图片
		    if (picUrl != '') {
		        this.picUrl = picUrl;
		        this.picDialog = true;
		    } else {
		        this.$message.error('没有可以预览的图片哦！');
		    }
		},
		handleCloseImgView() { //关闭图片
		    this.picDialog = false;
		    this.picUrl = '';
		},
        onSearch(searchFrom) {
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("sale/selSalePersonList", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.saleList = res.data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
		cellClick(item,title){
			if (title == '注销' || title == '启用') {
				let text = ''
				let status = ''
				if (item.status == 1) {
					text = '确认注销该销售账号？'
					status = '2'
				}
				if (item.status == 2) {
					text = '确认启用该销售账号？'
					status = '1'
				}
				
				this.$confirm(text, '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
					this.loading = true;
					let params = {
						person_id:item.id,
						status:status
					}
					this.$api.post("sale/upSalePersonStatus", params, res => {
					    //渲染结束后取消加载
					    this.loading = false;
						if (res.code == 0) {
							this.$message.success(res.msg);
							this.getData(this.searchForm);					   
						}else {
							this.$message.error(res.msg);
						}
					})
				
				}).catch(err=>{});
			}
			if (title == '修改提现比例') {
				this.changeForm.month_ratio = item.month_ratio
				this.changeForm.year_ratio = item.year_ratio
				this.changeForm.person_id = item.id
				this.changeWindowState = true
				
			}
			if (title == '奖励明细') {
				this.$router.push({
					path: '/saleRewardDetail',
					query: {
						person_id: item.id
					}
				});
			}
		},
		// 修改提现比例确定
		addSubmit(){
			
			this.$refs['changeForm'].validate((valid) => {
				if (valid) {
					this.loading = true;
					this.$api.post("sale/upSalePersonRatio", this.changeForm, res => {
					    //渲染结束后取消加载
					    this.loading = false;
						if (res.code == 0) {
							this.changeWindowState = false
							this.$message.success(res.msg);
							this.getData(this.searchForm);					   
						}else {
							this.$message.error(res.msg);
						}
					})
					
				}
				
			})
			
			
		}
    }
}
</script>

<style scoped lang="scss">
.merchantList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>